import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import ThemeProvider from '@mui/material/styles/ThemeProvider';
import { useTranslation } from 'react-i18next';
import { HeadingStyling } from './BiogTableStyles';
import ListItemLink from './ListItemLink';
import { LinkTheme } from './LinkTheme';

export default function BiogArtOrganizations() {
  const { t } = useTranslation('common');
  return (
    <ThemeProvider theme={LinkTheme}>
      <List sx={{pl:10}}>
        <ListItem sx={{p:0,m:0}}>
          <ListItemLink val='http://www.visarte-basel.ch/dossier.php?id=256&param=PRINT' label='Mitglied der Visarte, Berufsverband visuelle Kunst, Schweiz'/>
        </ListItem>
        <ListItem sx={{p:0,m:0}}>
          <ListItemLink val="http://www.sgbk.ch/index.php?id=406" label='SGBK'/>
        </ListItem>
        <ListItem sx={{p:0,m:0}}>
        <ListItemLink val="http://www.sikart.ch/KuenstlerInnen.aspx?id=4020498" label='SIKART'/>
        </ListItem>
        <ListItem sx={{p:0,m:0}}>
          <ListItemLink val="http://www.dock-basel.ch/nora_vest" label='Dock Basel'/>
        </ListItem>
      </List>
    </ThemeProvider>
  )
}
